import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    d="M12.2617 11.5742C14.3906 11.5742 16.1973 9.67969 16.1973 7.22852C16.1973 4.83594 14.3809 3 12.2617 3C10.1328 3 8.30664 4.86523 8.31641 7.24805C8.31641 9.67969 10.123 11.5742 12.2617 11.5742ZM6.16797 20.6562H18.3359C19.9473 20.6562 20.5039 20.168 20.5039 19.2695C20.5039 16.7598 17.3203 13.3027 12.252 13.3027C7.19336 13.3027 4 16.7598 4 19.2695C4 20.168 4.55664 20.6562 6.16797 20.6562Z"
    fill="black"
  />,
  'Person',
)
